import {combineReducers} from 'redux'

import AuthenticateReducer from './authenticate' // are you signed in/out
import UserReducers from './user'; // current signed in user information
import LayoutReducers from './layout'; // current layout
import SettingsReducers from './settings'

import {reducer as toastrReducer} from 'react-redux-toastr'

export default combineReducers({
  authenticate: AuthenticateReducer,
  user: UserReducers,
  layout: LayoutReducers,
  settings: SettingsReducers,
  toastr: toastrReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js